module.exports = __webpack_public_path__ + "static/media/BiggaPublishing_29.db373977.webp";